module.exports = __webpack_public_path__ + "static/media/nature.6009f45d.jpg";